import React from 'react';
import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';
import './StatsSection.css';

const StatsSection = () => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });

  return (
    <section className="stats-section" ref={ref}>
      <div className="container stats-grid">
        <div className="stat-item">
          <div className="stat-number">
            {inView && <CountUp end={100} duration={2.5} />}
            +
          </div>
          <div className="stat-label">Processes Streamlined</div>
        </div>
        <div className="stat-item">
          <div className="stat-number">
            {inView && <CountUp end={20} duration={2.5} />}
            +
          </div>
          <div className="stat-label">Years Of Expertise</div>
        </div>
        <div className="stat-item">
          <div className="stat-number">
            {inView && <CountUp end={5} duration={2.5} />}
            +
          </div>
          <div className="stat-label">Global Reach</div>
        </div>
        <div className="stat-item">
          <div className="stat-number">
            {inView && <CountUp end={50} duration={2.5} />}
            +
          </div>
          <div className="stat-label">Our Clients</div>
        </div>
      </div>
    </section>
  );
};

export default StatsSection;